// extracted by mini-css-extract-plugin
module.exports = {"input-none":"AddPhotoInput_input-none__1twHJ","wrapper":"AddPhotoInput_wrapper__1aLpS"};